import React from 'react';

const SvgCheck = (props) => (
  <svg width={12} height={9} {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.263.301c.156.148.312.31.453.472a.633.633 0 0 1 0 .886 2825.053 2825.053 0 0 0-6.403 6.685c-.694.723-.836.723-1.516 0C2.62 7.12 1.445 5.91.269 4.684a.68.68 0 0 1 0-.9c.156-.162.312-.31.453-.473a.59.59 0 0 1 .865 0c.992 1.034 1.983 2.052 2.96 3.085L10.4.301a.59.59 0 0 1 .865 0z"
    />
  </svg>
);

export default SvgCheck;
